import axios from "axios";
import React, { createContext, useState, useEffect, useContext } from "react";
import GlobalContext from "./GlobalProvider";

const ActiveCurrenciesContext = createContext();
export default ActiveCurrenciesContext;

export const ActivatedCurrencyProvider = ({ children }) => {
  const { defaultMapper } = useContext(GlobalContext);
  /** TblCurrMatching[] */
  const [activeCurrencies, setActiveCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  async function fetchCurrencyData() {
    setLoading(true);
    try {
      const response = await axios.get(`/api/Currency/active`);
      setActiveCurrencies(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (defaultMapper) {
      fetchCurrencyData();
    }
  }, [defaultMapper]);

  const contextValue = {
    loading,
    activeCurrencies,
    reloadActiveCurrencies: () => fetchCurrencyData(),
  };

  return (
    <ActiveCurrenciesContext.Provider value={contextValue}>
      {children}
    </ActiveCurrenciesContext.Provider>
  );
};
